<template>
  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">Permit Report</div>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <div class="grid">
            <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
              <label class="col-2">{{ $t("doc_date") }}</label>
              <DatePicker
                dateFormat="dd/mm/yy"
                v-model="header.Date_From"
                class="col-4"
              />
              <label class="col-1">To</label>
              <DatePicker
                dateFormat="dd/mm/yy"
                v-model="header.Date_To"
                class="col-4"
              />
            </div>
            <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
              <label class="col-2">{{ $t("created_date") }}</label>
              <DatePicker
                dateFormat="dd/mm/yy"
                v-model="header.Created_Date"
                class="col-4"
              />
              <label class="col-1">To</label>
              <DatePicker
                dateFormat="dd/mm/yy"
                v-model="header.Created_Date_To"
                class="col-4"
              />
            </div>
            <div class="col-12">
              <FormField
                fieldName="PermitType"
                :labelName="$t('permit_type')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.Type"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/permit_ref'"
                  :minLength="0"
                  :params="{}"
                  :filter="true"
                />
              </FormField>
              <FormField
                fieldName="Status"
                :labelName="$t('status')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.Status"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/lookup'"
                  :minLength="0"
                  :params="{ group: 'PERMIT_STATUS' }"
                  :filter="true"
                />
              </FormField>
              <FormField
                fieldName="ExecutorVendor"
                :labelName="$t('exe_vend')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.Executor"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/permit_vendorincompany'"
                  :minLength="0"
                  :params="{ companyCode: this.companyCodeUser }"
                  :filter="true"
                />
              </FormField>
              <FormField
                fieldName="Company"
                :labelName="$t('company')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.Company"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/workspace_user'"
                  :minLength="0"
                  :params="{
                    userId: this.idUser,
                    companyCode: this.companyCodeUser,
                  }"
                  :filter="true"
                />
              </FormField>
              <FormField
                fieldName="Department"
                :labelName="$t('department')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.Department"
                  class="p-inputtext-sm"
                  v-if="header"
                  :url="this.$API_URL + 'list/department_byidcoy'"
                  :minLength="0"
                  :params="{ companyId: this.companyIdUser }"
                  :filter="true"
                />
              </FormField>
              <FormField
                fieldName="StatusArea"
                :labelName="$t('status_area')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.StatusArea"
                  :url="$API_URL + 'list/lookup'"
                  :minLength="0"
                  :filter="true"
                  :params="{ group: 'STATUS_AREA', allow_all: false }"
                />
              </FormField>
              <FormField
                :labelName="$t('work_mtc')"
                fieldName="MtcType"
                v-model="header"
                labelClass="col-2"
                fieldClass="col-6"
                v-if="header"
              >
                <CustomSelect
                  v-model="header.MtcType"
                  v-if="header"
                  :url="this.$API_URL + 'list/mtctype_code'"
                  :minLength="0"
                  :filter="true"
                  :params="{}"
                />
              </FormField>
              <FormField
                fieldName="CreatedBy"
                :labelName="$t('created_by')"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="header.CreatedBy"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/user_company_bycode_createdby'"
                  :minLength="0"
                  :params="{ companyCode: this.companyCodeUser }"
                  :filter="true"
                />
              </FormField>
              <FormField
                :labelName="$t('work_moc')"
                fieldName="Moc"
                v-model="header"
                labelClass="col-2"
                fieldClass="col-6"
              >
                <YNSelect
                  :useBinary="true"
                  v-model="header.Moc"
                  v-if="header"
                />
              </FormField>
              <FormField
                :labelName="$t('work_proj')"
                fieldName="Proj"
                v-model="header"
                labelClass="col-2"
                fieldClass="col-6"
              >
                <YNSelect
                  :useBinary="true"
                  v-model="header.Proj"
                  v-if="header"
                />
              </FormField>
              <FormField
                :labelName="$t('is_deleted')"
                fieldName="IsDeleted"
                v-model="header"
                labelClass="col-2"
                fieldClass="col-6"
              >
                <YNSelect
                  :useBinary="true"
                  v-model="header.IsDeleted"
                  v-if="header"
                />
              </FormField>
            </div>
          </div>
        </div>
        <Button type="button" label="Generate" @click="getReport()" />
        &nbsp;
        <Button
          type="button"
          class="p-button-success"
          label="Reopen"
          @click="reopenTab()"
          v-show="this.reportTbl"
        />
      </template>
    </Card>
  </form>

  <ShowReport
    :title="title"
    :isVisible="showReport"
    :reportTbl="this.reportTbl"
    @close="resetBtn()"
  />
</template>

<script type="text/javascript">
import ShowReport from "../Report/ShowReport.vue";
import FormField from "../Base/Helper/FormField.vue";
export default {
  components: {
    ShowReport,
    FormField,
  },
  data() {
    name: "PermitReport";
    return {
      test: 0,
      mode: "",
      url: this.$API_URL + "report/",
      companyCodeUser: this.$store.getters.getCompanyCode,
      companyIdUser: this.$store.getters.getCompanyId,
      idUser: this.$store.getters.getUserId,
      userName: this.$store.getters.getUsername,
      reportTbl: null,
      showReport: false,
      loadingReport: false,
      mergedOptions: [
        { label: "Y", value: 1 },
        { label: "N", value: 0 },
      ],
      header: {
        Date_From: null,
        Date_To: null,
        Created_Date: null,
        Created_Date_To: null,
        Type: null,
        Status: null,
        Executor: null,
        Company: null,
        Department: null,
        StatusArea: null,
        MtcType: null,
        CreatedBy: null,
        Moc: null,
        Proj: null,
        IsDeleted: null,
      },
    };
  },
  methods: {
    reopenTab() {
      this.showReport = true;
    },
    resetBtn() {
      this.showReport = false;
    },
    tableToExcel() {
      this.loadingReport = !this.loadingReport;
    },
    getReport() {
      // this.visibleBar = true;
      // this.loadingReport = !this.loadingReport;
      if (
        this.header.Type == null &&
        this.header.Status == null &&
        this.header.Executor == null &&
        this.header.Company == null &&
        this.header.Department == null &&
        this.header.StatusArea == null &&
        this.header.MtcType == null &&
        this.header.CreatedBy == null &&
        this.header.Moc == null &&
        this.header.Proj == null &&
        this.header.IsDeleted == null
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Can't Generate",
          detail: "Min filling 1 field for generate",
          life: 3000,
        });
        return;
      }

      this.$emit("blockBody");
      this.$axios
        .post(this.url + "permit", this.header)
        .then((response) => {
          this.reportTbl = {
            header: response.data.data.header,
            content: response.data.data.content,
            title: response.data.data.title,
          };
          // this.showError(response);
          this.showReport = true;
          this.$emit("unblockBody");
        })
        .catch((exc) => {
          // this.showError(response);
          // //console.log(1);
          this.$emit("unblockBody");
        });
    },
    showError(msg) {
      this.loadingReport = !this.loadingReport;
    },
    closeReport() {
      this.showReport = false;
    },
  },
  mounted() {},
};
</script>
